import { Breadcrumb, BreadcrumbButton, BreadcrumbDivider, BreadcrumbItem, Skeleton, SkeletonItem } from "@fluentui/react-components";
import IBreadcrumbsProps from "./IBreadcrumbsProps";
import { HomeFilled } from "@fluentui/react-icons";
import IBreadcrumbItem from "./IBreadcrumbItem";
import { v4 as uuid } from 'uuid';
import { useLocation, useNavigate } from "react-router-dom";
import Status from "../../enums/Status";
import { useEffect, useState } from "react";
import { LoadBreadcrumbs } from "./LoadBreadcrumbs";
import { Col } from "react-grid-system";
import useStyleUtils from "../../utilities/styles";

const CurrentCrumb = ({ text }: { text: string }) => (
    <BreadcrumbItem>
        <BreadcrumbButton current>{text}</BreadcrumbButton>
    </BreadcrumbItem>
);

export default function Breadcrumbs(props: IBreadcrumbsProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const style = useStyleUtils();

    const [items, setItems] = useState<IBreadcrumbItem[]>([]);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    const lastCrumb = items[items.length - 1];

    useEffect(() => {
        loadBreadcrumbs(setItems, setStatus);
    }, [location.pathname]);

    if (status === Status.LOADING) {
        return (
            <Col>
                <Skeleton className={style.w50}>
                    <SkeletonItem size={36} />
                </Skeleton>
            </Col>
        );
    }

    return (
        <Col>
            <Breadcrumb>
                {
                    props.showHome &&
                    <>
                        <BreadcrumbItem>
                            <BreadcrumbButton onClick={() => navigate('/')}>
                                <HomeFilled />
                            </BreadcrumbButton>
                        </BreadcrumbItem>
                        
                        <BreadcrumbDivider />
                    </>
                }

                {
                    items
                        .filter((crumb: IBreadcrumbItem) => crumb !== lastCrumb || items.length === 1)
                        .map((crumb: IBreadcrumbItem) => (
                            <>
                                <BreadcrumbItem key={uuid()}>
                                    <BreadcrumbButton onClick={() => navigate(crumb.href!)}>
                                        {crumb.text}
                                    </BreadcrumbButton>
                                </BreadcrumbItem>
                                
                                {
                                    items.length > 1 &&
                                    <BreadcrumbDivider key={uuid()} />
                                }
                            </>
                        ))
                }

                {
                    items.length > 1 && <CurrentCrumb text={lastCrumb.text} />
                }
            </Breadcrumb>
        </Col>
    );
}

async function loadBreadcrumbs(
    setItems: (items: IBreadcrumbItem[]) => void,
    setStatus: (status: Status) => void
) {
    try {
        setStatus(Status.LOADING);

        const crumbs = await LoadBreadcrumbs();
        setItems(crumbs);
        setStatus(Status.LOAD_SUCCESS);
    } catch {
        setStatus(Status.LOAD_ERROR);
    }
}